import { api } from '@@/services/api';

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query<Alacaza.User, void>({
      query: () => `partners/me`,
      providesTags: ['Users'],
    }),
    getMyProperties: builder.query<Alacaza.MyProperties, void>({
      query: () => `partners/me/properties`,
      providesTags: ['MyProperties'],
    }),
    updateMyProperties: builder.mutation<
      Pick<Alacaza.MyProperties, 'selectedPropertyIds'>,
      { propertyIds: string[] | null }
    >({
      query: (body) => ({
        url: `partners/me/properties`,
        method: 'PATCH',
        body,
      }),
      // La sélection restreint toutes les listes côté API
      invalidatesTags: ['MyProperties', 'Properties', 'Incidents', 'Messages'],
    }),
    getUserById: builder.query<Alacaza.Resident, string>({
      query: (userId) => `users/${userId}`,
      providesTags: ['Residents'],
    }),
  }),
});

export const {
  useGetMeQuery,
  useGetMyPropertiesQuery,
  useUpdateMyPropertiesMutation,
  useGetUserByIdQuery,
} = userApi;
